export default __webpack_public_path__ + "static/media/icon-reservas.2dc41a6d.svg";